import api from './api';

export const get = query =>
	api.get('/commercial/technical-data', { params: query });
